"use strict";

module.exports = [
  { value: "child", label: "Child" },
  { value: "parent", label: "Parent" },
  { value: "spouse", label: "Spouse" },
  { value: "common", label: "Common Law Spouse" },
  { value: "other", label: "Other" },
  { value: "self", label: "Self" }
];
